module.exports = __webpack_public_path__ + "img/paper-plane.7b9e4fa6.svg";